import { Route, Routes } from "react-router-dom"

import CompaniesPage from "@/souhl_admin/components/features/companies/CompaniesPage"
import CompanyCreatePage from "@/souhl_admin/components/features/companies/CompanyCreatePage"
import CompanyDetailPage from "@/souhl_admin/components/features/companies/CompanyDetailPage"
import CompanyEditPage from "@/souhl_admin/components/features/companies/CompanyEditPage"
import KnownIssueCreatePage from "@/souhl_admin/components/features/known-issues/KnownIssueCreatePage"
import KnownIssueDetailPage from "@/souhl_admin/components/features/known-issues/KnownIssueDetailPage"
import KnownIssueEditPage from "@/souhl_admin/components/features/known-issues/KnownIssueEditPage"
import KnownIssuesPage from "@/souhl_admin/components/features/known-issues/KnownIssuesPage"
import TaigaPage from "@/souhl_admin/components/features/taiga/TaigaPage"
import UnknownIssueLogsPage from "@/souhl_admin/components/features/unknown-issue-logs/UnknownIssueLogsPage"

const SouhlAdmin = () => {
	return (
		<Routes>
			<Route path="/" element={<CompaniesPage />} />
			<Route path="/companies/create" element={<CompanyCreatePage />} />
			<Route path="/companies/:companyId" element={<CompanyDetailPage />} />
			<Route path="/companies/:companyId/edit" element={<CompanyEditPage />} />
			<Route path="/known_issues" element={<KnownIssuesPage />} />
			<Route path="/known_issues/create" element={<KnownIssueCreatePage />} />
			<Route path="/known_issues/:id" element={<KnownIssueDetailPage />} />
			<Route path="/known_issues/:id/edit" element={<KnownIssueEditPage />} />
			<Route path="/unknown_issue_logs" element={<UnknownIssueLogsPage />} />
			<Route path="/taiga" element={<TaigaPage />} />
		</Routes>
	)
}

export default SouhlAdmin
